import styled from 'styled-components';
import { FontWeight } from '../../../../styled/constants';
import { FlexCenterAligned, FlexibleDiv } from '../../../../styled/common';

export const ModalWrapper = styled.div`
  background: ${({ theme }) => theme.colors.background.primary};
  border-radius: 24px 24px 0 0;
  padding: 15px;
  min-height: 220px;
  margin-bottom: 20px;
`;

export const Header = styled(FlexCenterAligned)`
  position: relative;
  margin-bottom: 33px;
  margin-top: 5px;
`;

export const Title = styled.span`
  color: ${({ theme }) => theme.colors.text.white};
  font-size: 16px;
  font-weight: ${FontWeight.medium};
  text-align: center;
  width: 75%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const CloseButton = styled.button`
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background: none;
  border: none;
  cursor: pointer;
  line-height: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
`;

export const Card = styled.div`
  background: ${({ theme }) => theme.colors.systemColors.blue};
  border-radius: 17px;
  padding: 15px;
`;

export const CardContent = styled(FlexibleDiv)`
  align-items: center;
  justify-content: flex-start;
  width: 100%;
`;

export const Img = styled.img`
  width: 68px;
  height: 68px;
  border-radius: 12px;
  object-fit: cover;
  margin-right: 12px;
`;

export const CardInfo = styled.div`
  overflow: hidden;
`;

export const CardTitle = styled.div`
  color: ${({ theme }) => theme.colors.text.white};
  font-size: 15px;
  font-weight: ${FontWeight.medium};
  width: 100%;
`;

export const CardAddress = styled.div`
  color: ${({ theme }) => theme.colors.text.white};
  font-size: 13px;
  font-weight: ${FontWeight.thin};
  margin-top: 2px;
`;

export const DetailsBtn = styled.a`
  width: 100%;
  background: ${({ theme }) => theme.colors.systemColors.white};
  color: ${({ theme }) => theme.colors.systemColors.cocoaBrown};
  font-size: 16px;
  font-weight: ${FontWeight.thin};
  border: none;
  border-radius: 14px;
  padding: 16px 0;
  text-align: center;
  display: block;
  margin-top: 15px;
  text-decoration: none;
`;
